import React, { forwardRef } from 'react';
import { useNonMobileHover } from '@anton.bobrov/react-vevet-hooks';
import { useForwardedRef } from '@anton.bobrov/react-hooks';
import cx from 'classnames';
import { LoaderLogo } from '../../loaders/LoaderLogo/index.js';
import styles from './index.module.scss.js';
import { ShineIcon } from './icons/Shine.js';
import { ArcPseudoBg } from '../../../internal/ArcPseudoBg/index.js';

const GradientButton = forwardRef(
  ({
    className,
    style,
    size = "md-2",
    iconLeft,
    type = "button",
    kind = "fill",
    text,
    fullWidth,
    isLoading = false,
    animated = false,
    withShine = false,
    ...props
  }, forwardedRef) => {
    const ref = useForwardedRef(forwardedRef);
    const isHovered = useNonMobileHover(ref);
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        ...props,
        ref,
        type,
        className: cx(
          styles.box,
          className,
          {
            [styles[kind]]: !!kind,
            [styles.hover]: isHovered,
            [styles[size]]: !!size,
            [styles.full]: fullWidth
          },
          "gradient-button"
        )
      },
      iconLeft,
      (kind === "outline" || kind === "outline-2") && /* @__PURE__ */ React.createElement(ArcPseudoBg, { className: styles.bg, isBgActive: isHovered }),
      kind === "fill" && animated && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        "span",
        {
          className: cx(styles.shines, {
            [styles.hover]: isHovered
          })
        }
      ), /* @__PURE__ */ React.createElement(
        "span",
        {
          className: cx(styles.star, {
            [styles.hover]: isHovered
          })
        }
      )),
      isLoading ? /* @__PURE__ */ React.createElement(
        "div",
        {
          className: cx(styles.loader, {
            [styles["fade-out"]]: !isLoading,
            [styles["fade-in"]]: isLoading === true
          })
        },
        /* @__PURE__ */ React.createElement(LoaderLogo, null)
      ) : null,
      /* @__PURE__ */ React.createElement(
        "span",
        {
          className: cx(styles.text, {
            [styles.animated]: animated
          })
        },
        /* @__PURE__ */ React.createElement(
          "span",
          {
            className: cx(styles.text, {
              [styles["fade-out"]]: isLoading === true,
              [styles["fade-in"]]: isLoading === false
            })
          },
          text
        )
      ),
      withShine ? /* @__PURE__ */ React.createElement(ShineIcon, null) : null
    );
  }
);
GradientButton.displayName = "GradientButton";

export { GradientButton };
//# sourceMappingURL=index.js.map
